import { useContext } from 'react'

import {
  type BatchImportDispatch,
  BatchImportDispatchContext,
} from '@Features/data-management/context/BatchImportContext'

function useBatchImportDispatch(): BatchImportDispatch {
  try {
    const context = useContext(BatchImportDispatchContext)
    return context
  } catch (error) {
    throw new Error(
      'useBatchImportDispatch must be used within a BatchImportProvider',
    )
  }
}

export default useBatchImportDispatch
